import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import { Person, /* DoneAll, */ Group } from '@material-ui/icons'
import { AccountDetails, BellRing } from 'mdi-material-ui'
import { toggleBottomNav } from 'actions/contacts/addOrEdit'
import styles from 'components/TemplateForm/styles'
// import ConversationIcon from 'components/theme/ConversationIcon'

export default connect(
  state => ({
    bottomNavigation: state.contacts.bottomNav,
  }),
  dispatch => bindActionCreators({ toggleBottomNav }, dispatch),
)(
  withStyles(styles)(
    ({ toggleBottomNav, bottomNavigation, classes, mobile, dialog }) => (
      <BottomNavigation
        className={
          dialog
            ? classes.bottomNavDialog
            : mobile
            ? classes.bottomNavNoMarginMobile
            : classes.bottomNavNoMargin
        }
        onChange={(e, payload) => toggleBottomNav(payload)}
        value={bottomNavigation}
        showLabels
        style={{ display: 'flex', left: 0 }}
      >
        <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Contact Info"
          icon={<Person style={{ color: '#fff' }} />}
        />
        {/* <BottomNavigationAction
					classes={{
						root: classes.bottomNavAction,
						selected: classes.bottomNavActionSelected,
						label: classes.bottomNavLabel,
					}}
					label="Conversation"
					icon={<ConversationIcon style={{ color: '#fff' }} />}
				/> */}
        {/* <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Tasks"
          icon={<DoneAll style={{ color: '#fff' }} />}
        /> */}
        <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Groups"
          icon={<Group style={{ color: '#fff' }} />}
        />
        <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Custom Attributes"
          icon={<AccountDetails style={{ color: '#fff' }} />}
        />
        <BottomNavigationAction
          classes={{
            root: classes.bottomNavAction,
            selected: classes.bottomNavActionSelected,
            label: classes.bottomNavLabel,
          }}
          label="Activity"
          icon={<BellRing style={{ color: '#fff' }} />}
        />
      </BottomNavigation>
    ),
  ),
)
